import store from '../../store'
const target = store.state.target
const url = target + "/payserver"
export default {
  refunds: url + '/order/refunds', //充值退款
  queryOrders: url + '/order/queryOrders', //充值记录
}